module.exports = __webpack_public_path__ + "c23eab6d60cb87d15c513db36b08fe63.svg";